var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 293,
    height: 205.647,
    viewBox: "0 0 293 205.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dedos_indices",
    transform: "translate(-19.29 -28.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1840",
    "data-name": "Grupo 1840",
    transform: "translate(19.29 28.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1832",
    transform: "translate(158.965 0.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1825_1_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1822_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1821_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6041_2_",
    d: "M407.425,221.721l.258-20.434,13.881-11.4a34.357,34.357,0,0,0,7.018-7.947s4.438-12.952,13.468-21.982c3.973-3.973,4.747-9.856,6.14-13.726h0a52.447,52.447,0,0,1,6.3-12.178l7.069-10.269a4.218,4.218,0,0,0-1.084-5.831,5.634,5.634,0,0,0-.568-.31h0a15.01,15.01,0,0,0-14.861,1.032h0a63.235,63.235,0,0,0-16.925,16.615l-2.012,2.89a6.957,6.957,0,0,1-8.927,2.167h0l.619-28.432,2.425-73.273a10.07,10.07,0,0,0-4.128-8.463h0a7.526,7.526,0,0,0-7.637-.671h0a7.587,7.587,0,0,0-4.231,6.244l-7.947,65.894a1.091,1.091,0,0,1-1.187.929h-.155a1.1,1.1,0,0,1-.826-.98l-.516-6.811-1.445-1.29a8.543,8.543,0,0,0-5.16-6.5h0a8.4,8.4,0,0,0-8.411,1.084l-.671.516a8.53,8.53,0,0,0-3.354,6.811l-2.58,5.728a1.054,1.054,0,0,1-.826,1.032l-.877.206c-.052-.516-1.548-.052-1.806-.774-2.735-7.895-18.886-2.941-19.041,2.425-.413,16.615-.31-1.135,0,5.057a1.106,1.106,0,0,1-.568.98l-1.032.516-1.032-2.064c-1.909-3.973-6.244-6.553-13.416-3.148-3.3,4.18-4.231,3.3-4.18,7.74,0,0-.052-.1,1.393,9.546l4.438,63.727a23.807,23.807,0,0,0,5.108,11.455l3.2,3.87.155,19.454a10.051,10.051,0,0,0,7.895,10.836h0a107.085,107.085,0,0,0,41.126.722l6.5-1.135A10.151,10.151,0,0,0,407.425,221.721Z",
    transform: "translate(-328.247 -28.769)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6042_2_",
    d: "M443.4,370.066a35.3,35.3,0,0,0,19.557-6.966l-.1,10.527C459.964,370.737,449.334,370.685,443.4,370.066Z",
    transform: "translate(-383.521 -190.582)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6043_2_",
    d: "M372.49,370.35c-5.676.361-14.964-3.1-15.738.31l-.052-6.76S361.292,368.7,372.49,370.35Z",
    transform: "translate(-341.559 -190.969)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6044_2_",
    d: "M410.321,256.6c-2.116,3.767-2.322-24.356,18.06-34.366,6.708-3.3,23.169-5.779,28.019-12.436l-.413,18.112a6.636,6.636,0,0,0,3.612.774C454.234,228.015,424.976,230.389,410.321,256.6Z",
    transform: "translate(-367.057 -116.386)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6045_2_",
    d: "M330.687,186.026c-.31-1.961-.722-5.108-1.187-8.927,4.7,11.868,18.783-2.941,19.815-7.482l1.342,4.438h-1.7a1.106,1.106,0,0,0,.568-.98c-.052-.929-.1-2.786-.206-5.315,3.715,9.082,16.564,2.993,18.318-5.521l2.735,4.076.877-.206a1,1,0,0,0,.826-1.032L374.238,161s-1.084,3.56,2.167,5.057c4.9,2.219,13.881,2.735,17.647-3.767l.206,3.3a1.159,1.159,0,0,0,.826.98h0a1.063,1.063,0,0,0,1.29-.774v-.155l.413-3.509c1.135,6.3,17.286,8.927,21.414,5.521l-.1,2.89c-12.333-2.374-32.044-4.231-47.421-.98A131.016,131.016,0,0,0,330.687,186.026Z",
    transform: "translate(-328.394 -92.768)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6046_2_",
    d: "M374.4,284.8",
    transform: "translate(-350.125 -152.686)",
    fill: "#fbd2bb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2402_1_",
    transform: "translate(67.142 115.259) rotate(179.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6051",
    "data-name": "Trazado 6051",
    d: "M10.578,0h0A10.593,10.593,0,0,1,21.156,10.578V47.266A10.593,10.593,0,0,1,10.578,57.845h0A10.593,10.593,0,0,1,0,47.266V10.578A10.593,10.593,0,0,1,10.578,0Z",
    transform: "translate(0 0)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6052",
    "data-name": "Trazado 6052",
    d: "M10.114,0h0A10.13,10.13,0,0,1,20.228,10.114V46.8A10.13,10.13,0,0,1,10.114,56.916h0A10.13,10.13,0,0,1,0,46.8V10.114A10.13,10.13,0,0,1,10.114,0Z",
    transform: "translate(0.464 0.464)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2403_1_",
    transform: "translate(44.597 113.884) rotate(175.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6053",
    "data-name": "Trazado 6053",
    d: "M10.011,0h0A10.02,10.02,0,0,1,20.021,10.011V42.158A10.02,10.02,0,0,1,10.011,52.168h0A10.02,10.02,0,0,1,0,42.158V10.011A10.02,10.02,0,0,1,10.011,0Z",
    transform: "translate(0 0)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6054",
    "data-name": "Trazado 6054",
    d: "M9.546,0h0a9.558,9.558,0,0,1,9.546,9.546V41.693A9.558,9.558,0,0,1,9.546,51.24h0A9.558,9.558,0,0,1,0,41.693V9.546A9.558,9.558,0,0,1,9.546,0Z",
    transform: "translate(0.464 0.464)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2404_1_",
    transform: "translate(24.09 111.1) rotate(172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6055",
    "data-name": "Trazado 6055",
    d: "M9.495,0h0a9.47,9.47,0,0,1,9.495,9.495V28.484a9.47,9.47,0,0,1-9.495,9.495h0A9.47,9.47,0,0,1,0,28.484V9.495A9.5,9.5,0,0,1,9.495,0Z",
    transform: "translate(0 0)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6056",
    "data-name": "Trazado 6056",
    d: "M9.03,0h0a9.007,9.007,0,0,1,9.03,9.03V28.019a9.007,9.007,0,0,1-9.03,9.03h0A9.007,9.007,0,0,1,0,28.019V9.03A9.04,9.04,0,0,1,9.03,0Z",
    transform: "translate(0.464 0.516)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2405_1_",
    transform: "translate(64.308 114.53) rotate(179.026)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6057",
    "data-name": "Trazado 6057",
    d: "M6.656,0H9.495a6.673,6.673,0,0,1,6.656,6.657V9.34A6.673,6.673,0,0,1,9.495,16H6.656A6.673,6.673,0,0,1,0,9.34V6.657A6.64,6.64,0,0,1,6.656,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6058",
    "data-name": "Trazado 6058",
    d: "M6.192,0H9.03a6.21,6.21,0,0,1,6.192,6.192V8.875A6.21,6.21,0,0,1,9.03,15.067H6.192A6.21,6.21,0,0,1,0,8.875V6.192A6.177,6.177,0,0,1,6.192,0Z",
    transform: "translate(0.464 0.464)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2406_1_",
    transform: "translate(42.157 113.835) rotate(177)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6059",
    "data-name": "Trazado 6059",
    d: "M6.657,0H9.133A6.673,6.673,0,0,1,15.79,6.657V8.566a6.673,6.673,0,0,1-6.657,6.657H6.657A6.673,6.673,0,0,1,0,8.566V6.657A6.673,6.673,0,0,1,6.657,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6060",
    "data-name": "Trazado 6060",
    d: "M6.192,0H8.669a6.21,6.21,0,0,1,6.192,6.192V8.1a6.21,6.21,0,0,1-6.192,6.192H6.192A6.21,6.21,0,0,1,0,8.1V6.192A6.21,6.21,0,0,1,6.192,0Z",
    transform: "translate(0.464 0.464)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2407_1_",
    transform: "translate(21.066 110.995) rotate(173)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6061",
    "data-name": "Trazado 6061",
    d: "M5.677,0H7.586a5.66,5.66,0,0,1,5.676,5.676v1.6a5.66,5.66,0,0,1-5.676,5.676H5.677A5.66,5.66,0,0,1,0,7.276v-1.6A5.627,5.627,0,0,1,5.677,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6062",
    "data-name": "Trazado 6062",
    d: "M5.213,0H7.122a5.2,5.2,0,0,1,5.212,5.212v1.6a5.2,5.2,0,0,1-5.212,5.212H5.213A5.2,5.2,0,0,1,0,6.811v-1.6A5.165,5.165,0,0,1,5.213,0Z",
    transform: "translate(0.464 0.464)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1832_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1825_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1822_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1821_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6041_3_",
    d: "M82.455,231.476l6.5,1.135a107.085,107.085,0,0,0,41.126-.722h0a10.051,10.051,0,0,0,7.895-10.836l.155-19.454,3.2-3.87a24.078,24.078,0,0,0,5.108-11.455l4.438-63.727c1.5-9.649,1.393-9.546,1.393-9.546.052-4.438-.877-3.56-4.18-7.74-7.173-3.406-11.507-.826-13.416,3.148l-1.032,2.064-1.032-.516a1.106,1.106,0,0,1-.568-.98c.258-6.192.413,11.559,0-5.057-.155-5.366-16.306-10.372-19.041-2.425-.258.722-1.754.258-1.806.774l-.877-.206a1,1,0,0,1-.826-1.032l-2.58-5.728a8.6,8.6,0,0,0-3.354-6.811l-.671-.516a8.394,8.394,0,0,0-8.411-1.084h0a8.543,8.543,0,0,0-5.16,6.5l-1.445,1.29-.516,6.811a1.159,1.159,0,0,1-.826.98h-.155a1.091,1.091,0,0,1-1.187-.929L77.346,35.651a7.587,7.587,0,0,0-4.231-6.244h0a7.526,7.526,0,0,0-7.637.671h0a9.94,9.94,0,0,0-4.128,8.463l2.425,73.273.619,28.432h0a6.9,6.9,0,0,1-8.927-2.167l-2.012-2.89A64,64,0,0,0,36.53,118.574h0a15.01,15.01,0,0,0-14.861-1.032h0c-.206.1-.361.206-.568.31a4.209,4.209,0,0,0-1.084,5.831l7.069,10.269a55.571,55.571,0,0,1,6.3,12.178h0c1.393,3.87,2.167,9.753,6.14,13.726,9.03,9.03,13.468,21.982,13.468,21.982a33.331,33.331,0,0,0,7.018,7.947l13.881,11.4.258,20.434A10.025,10.025,0,0,0,82.455,231.476Z",
    transform: "translate(-19.29 -28.669)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6042_3_",
    d: "M125.3,373.627l-.1-10.527a34.4,34.4,0,0,0,19.557,6.966C138.771,370.685,128.141,370.737,125.3,373.627Z",
    transform: "translate(-70.55 -190.531)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6043_3_",
    d: "M234.79,363.9l-.052,6.76c-.774-3.406-10.011.1-15.738-.31C230.249,368.7,234.79,363.9,234.79,363.9Z",
    transform: "translate(-115.948 -190.918)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6044_3_",
    d: "M99.6,228.686a7.371,7.371,0,0,0,3.612-.774L102.8,209.8c4.85,6.656,21.311,9.185,28.019,12.436,20.434,10.011,20.176,38.133,18.06,34.366C134.276,230.389,105.018,228.015,99.6,228.686Z",
    transform: "translate(-58.159 -116.335)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6045_3_",
    d: "M152.424,169.766c-15.377-3.3-35.14-1.445-47.421.98l-.1-2.89c4.128,3.354,20.228.722,21.414-5.521l.413,3.509V166a1.063,1.063,0,0,0,1.29.774h0a1.1,1.1,0,0,0,.826-.98l.206-3.3c3.715,6.553,12.745,6.037,17.647,3.767,3.251-1.5,2.167-5.057,2.167-5.057l2.167,4.076a1.054,1.054,0,0,0,.826,1.032l.877.206,2.735-4.076c1.754,8.514,14.6,14.551,18.318,5.521-.1,2.528-.206,4.386-.206,5.315a1.106,1.106,0,0,0,.568.98h-1.7l1.342-4.438c1.032,4.541,15.119,19.35,19.815,7.482-.464,3.818-.877,6.966-1.187,8.927A125.579,125.579,0,0,0,152.424,169.766Z",
    transform: "translate(-60.724 -92.813)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6046_3_",
    d: "M231.9,284.8",
    transform: "translate(-122.191 -152.634)",
    fill: "#fbd2bb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2402_2_",
    transform: "translate(89.642 115.314) rotate(179.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6063",
    "data-name": "Trazado 6063",
    d: "M22.4,11,21.163,47.634A10.6,10.6,0,0,1,10.224,57.851h0A10.6,10.6,0,0,1,.007,46.912L1.245,10.224A10.6,10.6,0,0,1,12.184.007h0A10.612,10.612,0,0,1,22.4,11Z",
    transform: "translate(0 0)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6064",
    "data-name": "Trazado 6064",
    d: "M21.522,10.479,20.283,47.167a10.214,10.214,0,0,1-10.475,9.8h0A10.214,10.214,0,0,1,0,46.5L1.242,9.808A10.214,10.214,0,0,1,11.717,0h0A10.179,10.179,0,0,1,21.522,10.479Z",
    transform: "translate(0.416 0.467)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2403_2_",
    transform: "translate(116.664 113.438) rotate(175.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6065",
    "data-name": "Trazado 6065",
    d: "M25.482,11.756,19.909,43.439A10.049,10.049,0,0,1,8.3,51.592h0A10.049,10.049,0,0,1,.145,39.981L5.718,8.3A10.049,10.049,0,0,1,17.329.145h0A10.022,10.022,0,0,1,25.482,11.756Z",
    transform: "translate(0 0)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6066",
    "data-name": "Trazado 6066",
    d: "M24.506,11.193,18.934,42.876a9.527,9.527,0,0,1-11.043,7.74h0A9.527,9.527,0,0,1,.151,39.574L5.724,7.891A9.527,9.527,0,0,1,16.766.151h0A9.55,9.55,0,0,1,24.506,11.193Z",
    transform: "translate(0.511 0.459)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2404_2_",
    transform: "translate(136.591 110.45) rotate(172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6067",
    "data-name": "Trazado 6067",
    d: "M23.85,12.137,18.639,30.4a9.492,9.492,0,0,1-11.765,6.5h0A9.492,9.492,0,0,1,.372,25.14L5.584,6.874A9.492,9.492,0,0,1,17.349.372h0A9.538,9.538,0,0,1,23.85,12.137Z",
    transform: "translate(0 0)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6068",
    "data-name": "Trazado 6068",
    d: "M22.89,11.487,17.679,29.753A9.034,9.034,0,0,1,6.533,35.945h0A9.034,9.034,0,0,1,.341,24.8L5.552,6.533A9.034,9.034,0,0,1,16.7.341h0A9.011,9.011,0,0,1,22.89,11.487Z",
    transform: "translate(0.547 0.547)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2405_2_",
    transform: "translate(86.138 114.647) rotate(179.026)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6069",
    "data-name": "Trazado 6069",
    d: "M16.209,6.972l-.1,2.683a6.6,6.6,0,0,1-6.863,6.4l-2.838-.1a6.6,6.6,0,0,1-6.4-6.863L.109,6.4A6.6,6.6,0,0,1,6.972.006l2.838.1A6.634,6.634,0,0,1,16.209,6.972Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6070",
    "data-name": "Trazado 6070",
    d: "M15.28,6.508l-.1,2.683a6.138,6.138,0,0,1-6.4,5.934l-2.838-.1a6.138,6.138,0,0,1-5.934-6.4L.11,5.94A6.138,6.138,0,0,1,6.508.006l2.838.1A6.206,6.206,0,0,1,15.28,6.508Z",
    transform: "translate(0.464 0.464)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2406_2_",
    transform: "translate(108.618 114.014) rotate(177)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6071",
    "data-name": "Trazado 6071",
    d: "M15.978,7.618l-.206,1.858A6.668,6.668,0,0,1,8.444,15.41l-2.477-.258A6.668,6.668,0,0,1,.033,7.825L.24,5.967A6.668,6.668,0,0,1,7.567.033l2.477.258A6.6,6.6,0,0,1,15.978,7.618Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6072",
    "data-name": "Trazado 6072",
    d: "M14.948,7.053l-.206,1.858a6.141,6.141,0,0,1-6.76,5.47l-2.477-.258a6.141,6.141,0,0,1-5.47-6.76L.242,5.505A6.141,6.141,0,0,1,7,.036L9.479.294A6.083,6.083,0,0,1,14.948,7.053Z",
    transform: "translate(0.565 0.514)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2407_2_",
    transform: "translate(127.884 111.284) rotate(173)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6073",
    "data-name": "Trazado 6073",
    d: "M13.437,7.555,13.076,9.1a5.7,5.7,0,0,1-6.915,4.128L4.3,12.766A5.7,5.7,0,0,1,.176,5.852L.537,4.3A5.7,5.7,0,0,1,7.451.176L9.309.64A5.7,5.7,0,0,1,13.437,7.555Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6074",
    "data-name": "Trazado 6074",
    d: "M12.53,6.957l-.361,1.548a5.272,5.272,0,0,1-6.347,3.818l-1.858-.464A5.272,5.272,0,0,1,.146,5.513L.507,3.965A5.272,5.272,0,0,1,6.854.146L8.712.61A5.216,5.216,0,0,1,12.53,6.957Z",
    transform: "translate(0.442 0.494)",
    fill: "none",
    stroke: "#f9c3a1",
    strokeWidth: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_246_1_",
    transform: "translate(253.087 28.685)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_252",
    "data-name": "Elipse 252",
    cx: 9.03,
    cy: 9.03,
    r: 9.03,
    transform: "translate(0 0)",
    fill: "#89c34a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_253",
    "data-name": "Elipse 253",
    cx: 8.05,
    cy: 8.05,
    r: 8.05,
    transform: "translate(0.98 0.98)",
    fill: "#89c34a",
    stroke: "#89c34a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_246_2_",
    transform: "translate(60.41 28.685)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_254",
    "data-name": "Elipse 254",
    cx: 9.03,
    cy: 9.03,
    r: 9.03,
    transform: "translate(0 0)",
    fill: "#89c34a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_255",
    "data-name": "Elipse 255",
    cx: 8.05,
    cy: 8.05,
    r: 8.05,
    transform: "translate(0.98 0.98)",
    fill: "#89c34a",
    stroke: "#89c34a",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndices);
export default __webpack_public_path__ + "static/media/indices.a86b30b402b397610beec25fd8c21c4f.svg";
export { ForwardRef as ReactComponent };